// Action types
export const START_ONBOARDING = 'START_ONBOARDING';
export const ADVANCE_ONBOARDING_STEP = 'ADVANCE_ONBOARDING_STEP';
export const SET_ONBOARDING_STEP = 'SET_ONBOARDING_STEP';
export const SKIP_ONBOARDING = 'SKIP_ONBOARDING';
export const COMPLETE_ONBOARDING = 'COMPLETE_ONBOARDING';
export const RESET_ONBOARDING = 'RESET_ONBOARDING';
export const SET_ONBOARDING_TEST_MODE = 'SET_ONBOARDING_TEST_MODE';

// Action creators
export const startOnboarding = () => ({
  type: START_ONBOARDING,
});

export const advanceOnboardingStep = () => ({
  type: ADVANCE_ONBOARDING_STEP,
});

export const setOnboardingStep = (step: number) => ({
  type: SET_ONBOARDING_STEP,
  payload: { step },
});

export const skipOnboarding = () => ({
  type: SKIP_ONBOARDING,
});

export const completeOnboarding = () => ({
  type: COMPLETE_ONBOARDING,
});

export const resetOnboarding = () => ({
  type: RESET_ONBOARDING,
});

export const setOnboardingTestMode = (enabled: boolean) => ({
  type: SET_ONBOARDING_TEST_MODE,
  payload: { enabled },
});
